import { render, staticRenderFns } from "./PatientTypeIndex.vue?vue&type=template&id=14a8c49a&scoped=true&"
import script from "./PatientTypeIndex.vue?vue&type=script&lang=js&"
export * from "./PatientTypeIndex.vue?vue&type=script&lang=js&"
import style0 from "./PatientTypeIndex.vue?vue&type=style&index=0&id=14a8c49a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a8c49a",
  null
  
)

export default component.exports